import Tooltip from '@mui/material/Tooltip'
import {
  StyledPaper,
  StyledToggleButton,
  StyledToggleButtonGroup,
  StyledOption,
} from './CustomToggleButtonGroup.styles.ts'
import { ReactNode, MouseEvent } from 'react'

interface Props<T> {
  value: T
  options: T[]
  onChange: (value: T) => void
  renderOption?: (option: T) => ReactNode
  optionToString?: (option: T) => string
  getTooltipText?: (option: T) => string
}

function CustomToggleButtonGroup<T>({
  value,
  options,
  renderOption,
  optionToString = JSON.stringify,
  onChange,
  getTooltipText,
}: Props<T>) {
  const handleChange = (_: MouseEvent<HTMLElement>, stringValue: string) => {
    const newValue = options.find(
      (option) => optionToString(option) === stringValue,
    )

    onChange(newValue ?? value)
  }

  return (
    <StyledPaper elevation={0}>
      <StyledToggleButtonGroup
        exclusive
        size="small"
        value={optionToString(value)}
        onChange={handleChange}
      >
        {options.map((option, index) => (
          <Tooltip key={index} title={getTooltipText?.(option)}>
            <StyledToggleButton value={optionToString(option)}>
              {renderOption ? (
                renderOption(option)
              ) : (
                <StyledOption>{optionToString(option)}</StyledOption>
              )}
            </StyledToggleButton>
          </Tooltip>
        ))}
      </StyledToggleButtonGroup>
    </StyledPaper>
  )
}

export default CustomToggleButtonGroup
